import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const ContractService = {};
// ТЗ updated п.6.2: userId — если админ выбрал существующего ученика из списка,
// договор привязывается к нему напрямую, а не по совпадению email
ContractService.saveContract = async function (firstName, lastName, middleName, contractCategoryId, email, userId) {
    let data = new FormData();
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    if (middleName !== undefined) {
        data.append("middleName", middleName);
    }
    if (email !== undefined) {
        data.append("email", email);
    }
    data.append("contractCategoryId", contractCategoryId);
    if (userId) {
        data.append("userId", userId);
    }

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/contract/save",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ContractService.getContractsByUserID = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/contract/get/${id}`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        }
    });
}

ContractService.getAllContractCategories = async function () {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/contract-category/get`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ContractService.saveContractCategory = async function (nameEng, nameRu, nameKz) {
    let data = new FormData();
    data.append("nameEng", nameEng);
    data.append("nameRu", nameRu);
    data.append("nameKz", nameKz);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/contract-category/save",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ContractService.changeStatus = async function (contractId, status) {
    let data = new FormData();
    data.append("status", status);

    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/contract/${contractId}/change/status`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ContractService.getStudentsListAsExcel = async function () {

    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/contract/get/excel/1`,
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
        responseType: "blob"
    });
}

ContractService.getAllContractsPageable = async function (page, limit, name, categoryId, username, archived = false) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/contract/get?page=${page - 1}&limit=${limit}${name == null || name == undefined ? '' : '&name=' + name}${categoryId == null || categoryId == undefined ? '' : '&categoryId=' + categoryId}${username == null || username == undefined ? '' : '&username=' + username}&archived=${archived ? 'true' : 'false'}`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return { data, hasMore };
}

// п.4: архивировать/разархивировать договор
ContractService.setArchived = async function (contractId, archived) {
    return axios({
        method: "put",
        url: API_BASE_URL + `/api/admin/contract/${contractId}/archive`,
        params: {archived: archived},
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// п.4: авто-архивация договоров за 2025–2026
ContractService.autoArchive = async function (fromYear = 2025, toYear = 2026) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/contract/archive/auto`,
        params: {fromYear: fromYear, toYear: toYear},
        headers: {
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

// ТЗ updated п.3: счётчик считает с учётом вкладки Активные/Архив и поиска — как и таблица
ContractService.getAllContractsCount = async function (name, categoryId, username, archived = false) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/contract/get/count`,
        params: {
            name: name,
            categoryId: categoryId,
            username: username,
            archived: !!archived
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

ContractService.addFileToContract = async function (id, fileId) {
    let data = new FormData();
    data.append("fileId", fileId);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/contract/${id}/add/file`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}


export default ContractService;